export default {
    welcome: "Welcome",
    "customer-gallery": "Customer Gallery",
    "need-inspiration": "Need inspiration?",
    "get-inspired": "Get inspired",
    "get-inspired-desc": "From infographics and quizzes to microsites and videos, we have examples for every industry and content type that will spark your next idea.",
    "gtn-desc": "Expand your skills and develop your career while working for the best brands through the Rock Content platform",
    "talent-blog-desc": "A place you can find specialized content that will take your career to the next level.",
    "community-space-desc": "Rock Content's exclusive freelancer community.",
    "help-rock-content": "Rock Content Support.",
    "easy-access": "Easy access",
    "btn-open": "Open",
    "rock-university": {
        "highlighted-desc": "Rock your marketing skills!",
        desc: "Learn from the industry experts about content experiences, and interactive content strategy & execution.",
        "call-to-action": "Become an expert!",
    },
    "content-not-found": "Content not found",
    products: {
        studio: "Marketing collaboration for marketing teams and agencies.",
        ion: "Create interactive experiences without coding.",
        live: "Maximize the results of your Lives with tailor-made live experiences.",
        stage: "Managed Wordpress hosting and optimized content hubs.",
        iclips: "",
        "global talent network": "Develop your career while making marketing content for the best brands in Rock Content!",
        "rock university": "",
        "stage legacy": "Managed Wordpress hosting and optimized content hubs.",
    },
};
